const STATUS_PRESENTATIONS = Object.freeze({
    generated: {label: "Сформирован", tone: "neutral", known: true},
    draft: {label: "Черновик", tone: "neutral", known: true},
    approved: {label: "Одобрен", tone: "warning", known: true},
    exported: {label: "Экспортирован", tone: "warning", known: true},
    sent_to_bank: {label: "Передан в банк", tone: "warning", known: true},
    partially_paid: {label: "Частично оплачен", tone: "warning", known: true},
    paid: {label: "Оплачен", tone: "success", known: true},
    cancelled: {label: "Отменен", tone: "danger", known: true},
});

const READINESS_PRESENTATIONS = Object.freeze({
    ready: {label: "Готов к выплате", tone: "success", known: true},
    missing_requisites: {label: "Нет реквизитов", tone: "danger", known: true},
    missing_documents: {label: "Нет документов", tone: "danger", known: true},
    needs_review: {label: "Требует проверки", tone: "warning", known: true},
    on_hold: {label: "На удержании", tone: "warning", known: true},
});

const UNKNOWN_STATUS = Object.freeze({
    label: "Неизвестный статус",
    tone: "neutral",
    known: false,
});

const UNKNOWN_READINESS = Object.freeze({
    label: "Неизвестная готовность",
    tone: "neutral",
    known: false,
});

export const SETTLEMENT_ACTIONS = Object.freeze({
    approve: {label: "Одобрить", capability: "settlements.approve"},
    reopen: {label: "Вернуть в черновик", capability: "settlements.approve"},
    adjust: {label: "Добавить корректировку", capability: "settlements.adjust"},
    hold: {label: "Поставить на удержание", capability: "settlements.hold"},
    release_hold: {label: "Снять удержание", capability: "settlements.hold"},
    cancel: {label: "Отменить", capability: "settlements.cancel"},
    send_to_bank: {label: "Передать в банк", capability: "settlements.send_to_bank"},
    partial_paid: {label: "Записать частичную выплату", capability: "settlements.record_payment"},
    mark_paid: {label: "Отметить оплаченным", capability: "settlements.record_payment"},
});

const READINESS_REASON_LABELS = Object.freeze({
    active_hold: "Выплата удерживается оператором",
    missing_legal_name: "Не указано юридическое название",
    missing_bin_number: "Не указан БИН",
    missing_account_number: "Не указан расчетный счет",
    missing_currency: "Не указана валюта",
    missing_statement_currency: "Не указана валюта выписки",
    missing_documents: "Не хватает обязательных документов",
    needs_review: "Требуется ручная проверка",
    on_hold: "Выплата удерживается оператором",
    settlement_line_tenant_mismatch: "Строка относится к другой организации",
    settlement_line_company_mismatch: "Строка относится к другой компании",
    settlement_line_branch_mismatch: "Строка относится к другому филиалу",
    settlement_line_missing_currency: "В строке не указана валюта",
    settlement_line_currency_mismatch: "Валюта строки не совпадает с валютой выписки",
});

export const getSettlementStatusPresentation = (status) =>
    STATUS_PRESENTATIONS[status] || UNKNOWN_STATUS;

export const getReadinessPresentation = (status) =>
    READINESS_PRESENTATIONS[status] || UNKNOWN_READINESS;

export const getReadinessReasonLabel = (reason) =>
    READINESS_REASON_LABELS[reason] || String(reason || "Неизвестная причина").replace(/_/g, " ");

export const getSettlementActionPresentation = (action) => SETTLEMENT_ACTIONS[action] || null;

const visible = (requiredAction, enabled) => enabled(requiredAction);

export const getSettlementActions = (statement, hasAction) => {
    const status = getSettlementStatusPresentation(statement?.status);
    const readiness = getReadinessPresentation(statement?.readiness_status);
    if (!status.known || !readiness.known || typeof hasAction !== "function") return [];

    const candidates = [];
    const isHeld = statement.readiness_status === "on_hold";
    const isReady = statement.readiness_status === "ready";

    if (statement.status === "draft") {
        if (isReady) candidates.push("approve");
        candidates.push("adjust");
    }
    if (statement.status === "approved") candidates.push("reopen");
    if (statement.status === "exported" && isReady) candidates.push("send_to_bank");
    if (statement.status === "sent_to_bank" && isReady) {
        candidates.push("partial_paid", "mark_paid");
    }
    if (statement.status === "partially_paid" && isReady) {
        candidates.push("partial_paid");
    }
    if (statement.status !== "paid" && statement.status !== "cancelled") {
        candidates.push(isHeld ? "release_hold" : "hold");
    }
    if (statement.status === "draft" || statement.status === "approved") {
        candidates.push("cancel");
    }

    return candidates.filter((action) =>
        visible(SETTLEMENT_ACTIONS[action].capability, hasAction),
    );
};
